import React from 'react';
import { ButtonBase } from '@material-ui/core';
import FillParent from './layouts/FillParent';
import boundActions from '../store/actionCreators';

const Clickable = ({ disabled, actions, id, children }) => {
  const clickHandler = e => {
    const target = e.currentTarget;

    actions.forEach(a => {
      const key = Object.keys(a)[0];
      // need arguments as array; may be given as string
      const args = Array.isArray(a[key]) ? a[key] : [a[key]];
      const fn = boundActions[key];

      // if there's a payload object, add the event target as `payload.target`
      if (typeof args[0] === 'object' && target.id) {
        args[0].target = target.id;
      }

      // call the actions
      fn.apply(null, args);
    });
  };

  const Base = props => (
    <ButtonBase
      disabled={disabled}
      component="div"
      onClick={clickHandler}
      id={id}
      {...props}
    />
  );

  return (
    <>
      <FillParent as={Base} />
      {children}
    </>
  );
};

// only re-render when the disable prop changes
const skipRerender = (prevProps, nextProps) =>
  prevProps.disabled === nextProps.disabled;

export default React.memo(Clickable, skipRerender);
